export default theme => ({
  profile: {
    paddingRight: 10,
  },
});
